import { Component, Input, ElementRef, ViewChild, OnInit, EventEmitter, Output, TemplateRef } from '@angular/core';

import { GestockService } from '../services/gestock.service';
import { ReponseWebService } from '../datastruct/Meloyi.module';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';


@Component({
  selector: 'app-paiement',
  templateUrl: './paiement.component.html',
  styleUrls: ['./paiement.component.css']
})
export class PaiementComponent implements OnInit {
  montantTotal = 29500;
  montantRecu: number = 0;
  montantRestant: number;
  modePaiement: 'especes' | 'carte' | 'compte' | null = 'especes';
  avecFacture = true;
  dateEcheance: string = null; // échéance de la dette (Bon client), format yyyy-MM-dd
  dateMinEcheance: string = this.toIsoDate(new Date());

  @Input() customer: any;
  @Input() items: any[] = [];
  @Input() allQtsOnCart: any[] = [];
  @Input() factureId: string = '';
  @Input() date: string = new Date().toLocaleDateString();


  @Output() paiementInfoEvent = new EventEmitter<any>();

  samacaabiyoonwii = "";
  retourClientWS: any;

  @ViewChild('spinnerDialog', { static: false }) spinnerDialog: TemplateRef<any>;
  spinnerDialogRef: any;

  currentPanier: any;

  currentQtities: any;

  constructor(private dialog: MatDialog,
    private configServer: GestockService) {
  }

  ngOnInit() {
    this.samacaabiyoonwii = sessionStorage.getItem("samacaabiyoonwii");
    this.montantTotal = this.items.reduce((sum, item, index) => sum + this.allQtsOnCart[index] * item.prix, 0);
    this.montantRestant = this.montantTotal;

    this.currentPanier = JSON.parse(localStorage.getItem("panier"));

    this.currentQtities = JSON.parse(localStorage.getItem("qteOnCart"));

    // En modification, reprendre l'échéance déjà saisie sur la facture
    if (sessionStorage.getItem('editMode') === 'true') {
      let factureToEdit = JSON.parse(sessionStorage.getItem('factureToEdit') || 'null');
      if (factureToEdit && factureToEdit.date_echeance) {
        this.dateEcheance = String(factureToEdit.date_echeance).substring(0, 10);
      }
    }
  }

  toIsoDate(d: Date): string {
    const mm = ('0' + (d.getMonth() + 1)).slice(-2);
    const dd = ('0' + d.getDate()).slice(-2);
    return d.getFullYear() + '-' + mm + '-' + dd;
  }

  selectMode(mode: 'especes' | 'carte' | 'compte') {
    this.modePaiement = mode;
    this.montantRecu = 0;
    this.calculerRestant();
  }

  calculerRestant() {
    this.montantRestant = this.montantTotal - (this.montantRecu || 0);
  }

  getIconFor(mode: string): string {
    switch (mode) {
      case 'especes': return 'account_balance_wallet';
      case 'carte': return 'credit_card';
      case 'compte': return 'account_box';
      default: return 'help_outline';
    }
  }

  khamalMagMiLifiBees(state) {
    this.paiementInfoEvent.emit(state);
  }

  getLabelFor(mode: string): string {
    switch (mode) {
      case 'especes': return 'Espèces';
      case 'carte': return 'Carte';
      case 'compte': return 'Compte client';
      default: return '';
    }
  }


  validerPaiement() {
    this.commanderPanier();

    console.log({
      montant: this.montantTotal,
      recu: this.montantRecu,
      restant: this.montantRestant,
      mode: this.modePaiement,
      facture: this.avecFacture
    });
  }

  formatRestant() {
    if (this.montantRecu <= this.montantTotal)
      return this.montantRestant
    else
      return Math.abs(this.montantRestant);
  }


  commanderPanier() {
    let montantPayeSurCommande = 0;
    if (this.montantRecu <= this.montantTotal)
      montantPayeSurCommande = this.montantRecu;
    else
      montantPayeSurCommande = this.montantTotal;


    const dateEcheance = this.modePaiement === 'compte' && this.dateEcheance ? this.dateEcheance : null;

    this.openSpinnerDialog();

    let editMode = sessionStorage.getItem('editMode');
    if (editMode === 'true') {
      let factureToEdit = JSON.parse(sessionStorage.getItem('factureToEdit'));
      let oldNumcmd = factureToEdit.Numcmd;

      this.configServer.updateCommande(this.samacaabiyoonwii, oldNumcmd, this.currentPanier, this.currentQtities, this.modePaiement, montantPayeSurCommande, this.customer, dateEcheance).then((retourbi) => {
        this.handleResponse(retourbi);
      });
    } else {
      this.configServer.commanderPanier(this.samacaabiyoonwii, this.currentPanier, this.currentQtities, this.modePaiement, montantPayeSurCommande, this.customer, dateEcheance).then((retourbi) => {
        this.handleResponse(retourbi);
      });
    }
  }

  handleResponse(retourbi) {
    this.closeSpinnerDialog();
    this.retourClientWS = retourbi;
    console.log(this.retourClientWS);

    var statutreq = this.retourClientWS.statutreq;
    if (statutreq == 1) {
      let idFacture = "";
      const data = this.retourClientWS.data;

      if (data) {
        if (typeof data === 'object') {
          idFacture = data.idcmd || data.Numcmd || data.numcmd || data.id || '';
        } else if (typeof data === 'string') {
          if (data.startsWith('{')) {
            try {
              const parsed = JSON.parse(data);
              idFacture = parsed.idcmd || parsed.Numcmd || parsed.numcmd || parsed.id || '';
            } catch (e) {
              idFacture = data;
            }
          } else {
            idFacture = data;
          }
        } else {
          idFacture = String(data);
        }
      }

      if (!idFacture || idFacture === "Updated") {
        let factureToEdit = JSON.parse(sessionStorage.getItem('factureToEdit') || 'null');
        if (factureToEdit && factureToEdit.Numcmd) {
          idFacture = factureToEdit.Numcmd;
        }
      }

      sessionStorage.setItem("montantrecu", (this.montantRecu || 0).toString());

      // Nettoyage de l'edit mode
      sessionStorage.removeItem('editMode');
      sessionStorage.removeItem('factureToEdit');

      this.khamalMagMiLifiBees(idFacture);
      console.log("Opération Réussie !");
    }
    else {
      console.log("Echec de l'Opération !");
    }
  }


  openSpinnerDialog() {
    this.spinnerDialogRef = this.dialog.open(this.spinnerDialog);
  }

  closeSpinnerDialog() {
    this.spinnerDialogRef.close();
  }



}
